<div class="modal-header">
  <h4 class="modal-title">
    {{'managePropertiesDef.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form novalidate [formGroup]="form">
      <div class="col-12 mb-3 row">
        <label class="col-md-4 col-form-label ps-2">{{'property.type.label' | translate}}</label>
        <div class="col-md-8">
          <select class="form-control" id="propertyType" name="propertyType" formControlName="propertyType" (change)="switchPropertyNames()">
            <option [ngValue]="PropertyTypes.BEHAVIOR">{{'property.type.behavior' | translate}}</option>
            <option [ngValue]="PropertyTypes.PLAUSI">{{'property.type.plausi' | translate}}</option>
            <option [ngValue]="PropertyTypes.CONNECTION">{{'property.type.connection' | translate}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="propertyNames" class="overflow-xh">
        <table class="table table-striped table-hover number-mapping-table p-0">
          <thead class="col-12 d-flex flex-column p-0">
            <tr class="d-flex col-12 p-0">
              <th class="col-10">{{'managePropertiesDef.propertyName' | translate}}</th>
              <th class="col-2 dots">
                <span class="dropdown" dropdown #dropdown="bs-dropdown">
                  <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical"></i></a>
                  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a class="dropdown-item" data-gatm="property_action.add"
                         (click)="openAddPropertyDialog()">
                        <i class="mdi mdi-plus"></i>{{'global.label.add' | translate}}
                      </a>
                    </li>
                  </ul>
                </span>
              </th>
            </tr>
          </thead>
          <ng-scrollbar style="height: 500px;" [visibility]="'hover'">
            <tbody minRowCount [update]="update" class="col-12 d-flex flex-column p-0">
              <tr *ngFor="let property of propertyNames" class="col-12 d-flex p-0">
                <td class="col-10"><span>{{property}}</span></td>
                <td class="col-2 dots">
                  <span class="dropdown" dropdown #dropdown="bs-dropdown">
                    <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer"></i></a>
                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a class="dropdown-item" (click)="openEditPropertyDialog(property)"><i class="mdi mdi-pencil"></i>{{'global.label.edit' | translate}}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="delete(property)"><i class="mdi mdi-delete"></i>{{'global.label.delete' | translate}}
                        </a>
                      </li>
                    </ul>
                  </span>
                </td>
              </tr>
            </tbody>
          </ng-scrollbar>
        </table>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.close' | translate }}
  </button>
</div>
